import _ from 'lodash';
import { getKeyFromStreamUrl } from '../../../utils';
import { getKeyFromStreamUrlAudio } from '../../../utils';
import ACLService from '../../acl/services/aclService';
import { Attachment } from '../../common/MyPATUploader';
import contentService from '../services/contentService';
import * as JSLZString from 'lz-string';
import { NOTES_SECTION, PERMISSION_QUESTION_CONTENT_TYPES, PERMISSION_TEST_CONTENT_TYPES, TYPE_OF_CONTENT } from '../../../constants/comman';
const getPageNumber = (key: any): any => {
    const extractNumber = key.replace(/^\D+/g, '');
    return extractNumber;
}

const validateCustomDescription = (description: any) => {
    const mainContent = description.replace(/(&nbsp;|<([^>]+)>)/ig, '');
    if (mainContent.length > 180) {
        return true;
    }
}

const getAllowedToPermision = (allowedToData: any, userD: any) => {
    const authUserClientId = _.get(userD, "authenticatedUser.clientId._id", '');
    const authUserId = _.get(userD, "authenticatedUser._id", '');

    const userSpecificAllowedToData = allowedToData.filter(
        (data: any) => {
            return !!_.get(data, 'user.id')   
        }
      )
    const clientSpecificAllowedToData = allowedToData.filter(
        (data: any) => {
            return !!_.get(data, 'clientId')   
        }
      );

    // First try to find from userSpecificAllowedToData for user specific permissions
    let allowedToPermission = userSpecificAllowedToData.filter((data: any) => {
        return _.get(data, 'user.id')  === authUserId
    });
    if(allowedToPermission.length > 0) {
        return allowedToPermission;
    }
    // If no user specific permissions then find client based permission
    return clientSpecificAllowedToData.filter((data: any) => {
        return data.clientId === authUserClientId
    })
    
}

export const getEditRights = (allowedToData: any, module: string, createdByEmail: string, contentAclMetaData: any) => {
    if(module === 'studymaterial'){
        module = 'studyMaterial'
    } else if(module === 'testpapers') {
        module = 'test'
    }
    const userD = ACLService.getUserDetailsFromStorage();
    const authUserClientId = _.get(userD, "authenticatedUser.clientId._id", '');
    const creatorClientId = _.get(contentAclMetaData, 'clientId', '')

    

    let intersection = [];
    
    const allowedToPermission = getAllowedToPermision(allowedToData, userD);

    const permissions = _.get(userD, "authenticatedUser.role.permissions", []);
    const permissionForModule = permissions.filter(
        (data: any) => data.module === module
      );


    

    const requestCreatedBy = createdByEmail ===  _.get(userD, "authenticatedUser.email", '')
    if(!requestCreatedBy){
        if(authUserClientId === creatorClientId) {
            if(permissionForModule.length === 0) {
                return [];
            }
            return permissionForModule[0].sections.map(({ module }: any) => module);
        }
        if(_.get(allowedToPermission, "[0].sectionWiseAccess[0].sections", []).length > 0){
            intersection = _.get(allowedToPermission, "[0].sectionWiseAccess[0].sections", []).filter((item1: any) => permissionForModule[0].sections.some((item2: any) => item1.module === item2.module))
            intersection = intersection.map((value: any) => value.module);
        } else {
            const accessAllowed = _.get(allowedToPermission, '[0].accessAllowed', [])
            if(accessAllowed.includes('EDIT')) {
                intersection =  _.get(permissionForModule, "[0].sections", []).map((value: any) => value.module);
            }
        }
    } else {
        intersection = getDefaultPermissionIntersection(module);
    }

    return intersection;

}

const getDefaultPermissionIntersection = (module: string) => {
    let intersection: string[] = [];
    if(PERMISSION_QUESTION_CONTENT_TYPES.includes(module)) {
        intersection = ['content', 'options', 'answer', 'idealTime', 'syllabus', 'hints', 'solution', 'difficulty',
        'relevantExams', 'benchmarking', 'tags']
    } else if(PERMISSION_TEST_CONTENT_TYPES.includes(module)) {
        intersection = ['basicDetails', 'syllabus', 'format', 'questions']
    } else {
        intersection = ['notes', 'tags', 'syllabus']
    }
    return intersection;
}

export const notePayload =async (pages: any, pageKeyName: any, attempt: any,pdfAttachments?:File[] | string) => {
    let payLoadArray: any = [];
    let descriptionError: any = false;
    let pdfUrl:any;
    if(pdfAttachments && !_.isEmpty(pdfAttachments)) {
        if(typeof pdfAttachments === "string") {
            pdfUrl = pdfAttachments;
        } else {
        //@ts-ignore
        pdfUrl=await getAttachmentServerURl(
            pdfAttachments[0],
        );
        }
      if(typeof(pdfUrl) === "string"){
        payLoadArray.push(
            {
                "type": "PDF",
                "pageNumber": 1,
                "metaData": {
                    "pdf" : {
                        "url":pdfUrl
                    }
                }
            }
        )
      }else{
        payLoadArray.push(
            {
                "type": "PDF",
                "pageNumber": 1,
                "metaData": {
                    "pdf" : pdfUrl.data
                }
            }
        )
      }
      }
    // pages.forEach((pageData: any, index: any) => {
    //     if (pageData.pageContentType === 'Video') {
    //         if (validateCustomDescription(pageData['video'].videoDescription)) {
    //             descriptionError = true;
    //         }
    //     }
    // });
    //if (!descriptionError) {
      else{
        pages.forEach((pageData: any, index: any) => {
            switch (pageData.pageContentType) {
                case 'Question':
                    payLoadArray.push(
                        {
                            "type": "QUESTION",
                            "pageNumber": getPageNumber(pageKeyName[index]),
                            "metaData": {
                                "question": {
                                    id: pageData['question'].content_Id,
                                    instruction: pageData['question'].addInstruction,
                                    contentId: pageData['question'].searchId,
                                    attempt: attempt[`page${getPageNumber(pageKeyName[index])}`],
                                    subHeading: pageData['question'].subHeading,
                                    passageId: pageData['question'].passageId
                                }
                            }
                        }
                    )
                    break;


                case 'Theory':
                    payLoadArray.push({
                        "type": "THEORY",
                        "pageNumber": getPageNumber(pageKeyName[index]),
                        "metaData": {
                            "theory": {
                                "content": pageData['theory'].theoryDescription,
                                "subHeading": pageData['theory'].subHeading
                            }
                        }
                    })
                    break;

                case 'Video':
                    let newUrl = (pageData && pageData['video'] && pageData['video'].videoURL) ? JSLZString.decompressFromEncodedURIComponent(pageData['video'].videoURL): '';
                    if (!newUrl) {
                        newUrl = '';
                    }
                    let subHeading = pageData['video'].subHeading || '';

                    payLoadArray.push({
                        "type": "VIDEO",
                        "pageNumber": getPageNumber(pageKeyName[index]),
                        "metaData": {
                            "video": {
                                "title": pageData['video'].videoTitle,
                                "description": pageData['video'].videoDescription,
                                "uri": getKeyFromStreamUrl(newUrl),
                                // uncomment commentID and id if requirement comes to support displaying question in video notes
                                // "contentId": pageData['video'].contentId || null,
                                // "id": pageData['video'].id || '',
                                subHeading
                            },
                        }
                    });
                    break;
                case 'Audio':
                    newUrl = (pageData && pageData['audio'] && pageData['audio'].videoURL) ? JSLZString.decompressFromEncodedURIComponent(pageData['audio'].videoURL): '';
                    if (!newUrl) {
                        newUrl = '';
                    }
                    subHeading = pageData['audio'].subHeading || '';

                    payLoadArray.push({
                        "type": "AUDIO",
                        "pageNumber": getPageNumber(pageKeyName[index]),
                        "metaData": {
                            "audio": {
                                "title": pageData['audio'].videoTitle,
                                "description": pageData['audio'].videoDescription,
                                "uri": getKeyFromStreamUrlAudio(newUrl),
                                "contentId": pageData['audio'].contentId || null,
                                "id": pageData['audio'].id || null,
                                subHeading
                            },
                        }
                    });
                    break;
            }
        });
      }
      return new Promise((res,rej)=>{
            return res(payLoadArray);
        });
    // } else {
    //     return payLoadArray;
    // }
}

export const setAddConceptAndChapter = (notesData: any) => {
    let conceptCode: any[] = [];
    let newNotesData = { ...notesData };

    notesData.subjects && notesData.subjects.forEach((subject: any) => {
        const newSubject = {
            checked: _.get(subject, 'subjectId.checked') || false,
            subjectId: _.get(subject, 'subjectId._id'),
            subSubjects: {
                checked: _.get(subject, 'subSubjects[0].subSubjectId.checked') || false,
                subSubjectId: _.get(subject, 'subSubjects[0].subSubjectId._id'),
                chapters: {
                    checked: _.get(subject, 'subSubjects[0].chapters[0].chapterId.checked') || false,
                    chapterId: _.get(subject, 'subSubjects[0].chapters[0].chapterId._id'),
                    concepts: {
                        checked: _.get(subject, 'subSubjects[0].chapters[0].concepts[0].conceptId.checked') || false,
                        conceptId: _.get(subject, 'subSubjects[0].chapters[0].concepts[0].conceptId._id'),
                        conceptCode: _.get(subject, 'subSubjects[0].chapters[0].concepts[0].conceptCode'),
                        classId: _.get(subject, 'subSubjects[0].chapters[0].concepts[0].classId._id')
                    }
                }
            }
        }
        conceptCode.push(_.get(newSubject, 'subSubjects.chapters.concepts.conceptCode', ''))
    })

    notesData.secondarySubjects && notesData.secondarySubjects.forEach((subject: any) => {
        const newSubject = {
            checked: _.get(subject, 'subjectId.checked') || false,
            subjectId: _.get(subject, 'subjectId._id'),
            subSubjects: {
                checked: _.get(subject, 'subSubjects[0].subSubjectId.checked') || false,
                subSubjectId: _.get(subject, 'subSubjects[0].subSubjectId._id'),
                chapters: {
                    checked: _.get(subject, 'subSubjects[0].chapters[0].chapterId.checked') || false,
                    chapterId: _.get(subject, 'subSubjects[0].chapters[0].chapterId._id'),
                    concepts: {
                        checked: _.get(subject, 'subSubjects[0].chapters[0].concepts[0].conceptId.checked') || false,
                        conceptId: _.get(subject, 'subSubjects[0].chapters[0].concepts[0].conceptId._id'),
                        conceptCode: _.get(subject, 'subSubjects[0].chapters[0].concepts[0].conceptCode'),
                        classId: _.get(subject, 'subSubjects[0].chapters[0].concepts[0].classId._id')
                    }
                }
            }
        }
        conceptCode.push(_.get(newSubject, 'subSubjects.chapters.concepts.conceptCode', ''))
    })

    newNotesData.conceptCode = conceptCode;
    return newNotesData;
} 

export const pagesInArrayForm = (pageState: any) => {
    let filterPages: any = [];
    Object.keys(pageState).map((key: any) => {
        filterPages.push({ ...pageState[key] });
    });
    return filterPages;

}
export const getAttachmentServerURl = async (
  attachment: File,
) => {
  try {
    const encryptedPdf = await contentService.encryptPdf({
        file: attachment
    });
 
   /*const response = await contentService.generatePresignedUrl({
        key: attachment.name,
        location: location,
         acl: 'private', 
      });
      const {
        data: { fields, url },
      } = response;
      const { key } = fields;
      await contentService.uploadAttachment({
        file: file,
        uploadUrl: url,
        s3Fields: fields,
      });*/
  
      return encryptedPdf;
  

     } catch (error) {
    throw error;
  }
};

export function getTypeOfNotes(notesType: NOTES_SECTION) {

    let contentCategory;

    switch (notesType) {
        case NOTES_SECTION.CPP_OBJECTIVE:
            contentCategory = TYPE_OF_CONTENT.CPP_OBJECTIVE;
            break;

        case NOTES_SECTION.CPP_SUBJECTIVE:
            contentCategory = TYPE_OF_CONTENT.CPP_SUBJECTIVE;
            break;

        case NOTES_SECTION.ASSIGNMENT_OBJECTIVE:
            contentCategory = TYPE_OF_CONTENT.ASSIGNMENT_OBJECTIVE;
            break;

        case NOTES_SECTION.ASSIGNMENT_SUBJECTIVE:
            contentCategory = TYPE_OF_CONTENT.ASSIGNMENT_SUBJECTIVE;
            break;

        case NOTES_SECTION.WORKBOOK_OBJECTIVE:
            contentCategory = TYPE_OF_CONTENT.WORKBOOK_OBJECTIVE;
            break;

        case NOTES_SECTION.WORKBOOK_SUBJECTIVE:
            contentCategory = TYPE_OF_CONTENT.WORKBOOK_SUBJECTIVE;
            break;

        case NOTES_SECTION.ARCHIVE_OBJECTIVE:
            contentCategory = TYPE_OF_CONTENT.ARCHIVE_OBJECTIVE;
            break;

        case NOTES_SECTION.ARCHIVE_SUBJECTIVE:
            contentCategory = TYPE_OF_CONTENT.ARCHIVE_SUBJECTIVE;
            break;

        default: contentCategory = TYPE_OF_CONTENT.NOTES;
    }

    return contentCategory;
}